export default {
  'exception-500.exception.back': '返回首页',
  'exception-500.description.500': '抱歉，服务器出错了',
};
